import React from 'react'
import "./OurSuccessCount.css"

export default function OurSuccessCount() {
    return (
        <section className='our-success-count'>
            <div className='bg-text-holder'>
                <h1>STATS</h1>
            </div>
            <h2>Our Sucess Count</h2>
            <div className='counter'>
                <div className='container'>
                    <div className='row rowdiv'>
                        <div className='content col-md-3  col-sm-6 col-6'>
                            <h1>10000</h1>
                            <p className='mb-0'>All Time Clients</p>
                        </div>
                        <div className='content col-md-3 col-sm-6 col-6'>
                            <h1>979</h1>
                            <p className='mb-0'>Clients This Year</p>
                        </div>
                        <div className='content col-md-3 col-sm-6 col-6'>
                            <h1>300</h1>
                            <p className='mb-0'>New Claims</p>
                        </div>
                        <div className='content col-md-3 col-sm-6 col-6'>
                            <h1>35%</h1>
                            <p className='mb-0'>Avg Profit Increased</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
